import React, { useEffect } from 'react';

import { Box, Flex, xcss } from '@atlaskit/primitives';

import { ContentHistoryHeader } from './ContentHistoryHeader';
import { ContentHistoryPanel } from './ContentHistoryPanel';

const wrapperStyles = xcss({
	width: '100%',
	height: '100%',
});

const editorAndHeaderWrapperStyles = xcss({
	width: '70%',
	height: '100%',
});

const editorPlaceholderStyles = xcss({
	backgroundColor: 'color.background.accent.blue.subtlest',
	height: 'calc(100% - 56px)', // Subtracting the 56px height of the header
});

const panelStyles = xcss({
	width: '30%',
});

type NewContentHistoryProps = {
	contentId: string;
	hideNewContentHistory: () => void;
	spaceKey: string;
	isLivePage: boolean;
};

// @ts-ignore: Temporarily ignoring unused 'props' and will use these later
export const NewContentHistory = (props: NewContentHistoryProps) => {
	const { hideNewContentHistory } = props;

	useEffect(() => {
		// On unmount, hide content history in case user navigates away without using the back button
		return () => {
			hideNewContentHistory();
		};
	}, [hideNewContentHistory]);

	return (
		<Flex xcss={wrapperStyles}>
			<Flex direction="column" xcss={editorAndHeaderWrapperStyles}>
				<ContentHistoryHeader hideNewContentHistory={hideNewContentHistory} />
				<Flex xcss={editorPlaceholderStyles}> Editor placeholder </Flex>
			</Flex>
			<Box xcss={panelStyles}>
				<ContentHistoryPanel />
			</Box>
		</Flex>
	);
};
